module.exports = __webpack_public_path__ + "static/img/h1_icon2.c3a0720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/h1_icon2.png
// module id = ottM
// module chunks = 0